import { RokovaniePov, RokovaniePovApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new RokovaniePovApi(apiConfiguration(elegislativaPrefixPath));

const map = (poradneOrganyVlady: Array<string>): RokovaniePov => ({
  poradneOrganyVlady,
});

// eslint-disable-next-line import/prefer-default-export
export const startRokovaniePov = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: string,
  poradneOrganyVlady: Array<string>,
  headers?: object,
): Promise<ClientResponse<void>> => {
  // eslint-disable-next-line max-len
  const { status } = await client.startRokovaniePov(type, year, index, pracovnyKrokId, map(poradneOrganyVlady), headers);
  return {
    responseCode: status,
  };
};
